import React from 'react';
import styled from 'styled-components';

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  removeMargin,
  scrollTargetId = 'list-top',
  disabled,
}: {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  removeMargin?: boolean;
  scrollTargetId?: string;
  disabled?: boolean;
}) => {
  const handleChangePage = (page: number) => {
    onPageChange(page);

    if (disabled) return;
    const listTop = document.getElementById(scrollTargetId);
    if (listTop) {
      const y = listTop.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: y, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 3; // 표시할 최대 페이지 수 (중간에 '...' 포함)
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (startPage > totalPages - maxVisiblePages + 1) {
      startPage = Math.max(1, totalPages - maxVisiblePages + 1);
      endPage = totalPages;
    }

    if (totalPages > 5 && currentPage > 3) {
      // 첫 번째 페이지는 항상 표시
      // if (startPage > 1) {
      //   pageNumbers.push(
      //     <div key={1} onClick={() => onPageChange(1)}>
      //       <PageNumberText isActive={1 === currentPage}>{1}</PageNumberText>
      //     </div>,
      //   );
      // }
      // // '...' 표시 (왼쪽)
      // if (startPage > 1 && currentPage > 3) {
      //   pageNumbers.push(
      //     <div key="dots-left">
      //       <PageNumberText isActive={false}>...</PageNumberText>
      //     </div>,
      //   );
      // }
    }
    // 페이지 번호 표시 (중간 페이지들)
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <div key={i} onClick={() => handleChangePage(i)}>
          <PageNumberText isActive={i === currentPage}>{i}</PageNumberText>
        </div>,
      );
    }

    if (totalPages > 5) {
      // '...' 표시 (오른쪽)
      if (endPage - 1 < totalPages && currentPage < totalPages - 2) {
        pageNumbers.push(
          <div key="dots-right">
            <PageNumberText isActive={false}>...</PageNumberText>
          </div>,
        );
      }

      // 마지막 페이지는 항상 표시
      if (endPage - 1 < totalPages && currentPage < totalPages - 2) {
        pageNumbers.push(
          <div key={totalPages} onClick={() => handleChangePage(totalPages)}>
            <PageNumberText isActive={totalPages === currentPage}>
              {totalPages}
            </PageNumberText>
          </div>,
        );
      }
    }
    return pageNumbers;
  };
  return (
    <PaginationContainer removeMargin={removeMargin}>
      <ArrowBox isEnabled={currentPage !== 1}>
        <ArrowButton
          style={{
            width: '36px',
            height: '36px',
            transform: currentPage !== 1 ? 'rotate(180deg)' : '',
          }}
          onClick={currentPage !== 1 ? () => handleChangePage(1) : () => {}}
        >
          {currentPage !== 1 ? (
            <img src="/assets/images/arrow/double_arrow_right_on.svg" alt="" />
          ) : (
            <img src="/assets/images/arrow/double_arrow_left_off.svg" alt="" />
          )}
        </ArrowButton>
        <ArrowButton
          onClick={
            currentPage !== 1
              ? () => handleChangePage(currentPage - 1)
              : () => {}
          }
        >
          {currentPage !== 1 ? (
            <img src="/assets/images/arrow/pageLeftOn.svg" alt="" />
          ) : (
            <img src="/assets/images/arrow/pageLeftOff.svg" alt="" />
          )}
        </ArrowButton>
      </ArrowBox>
      <PageNumbersContainer>{renderPageNumbers()}</PageNumbersContainer>
      <ArrowBox isEnabled={currentPage !== totalPages}>
        <ArrowButton
          onClick={
            currentPage !== totalPages
              ? () => handleChangePage(currentPage + 1)
              : () => {}
          }
        >
          {currentPage !== totalPages ? (
            <img src="/assets/images/arrow/pageRightOn.svg" alt="" />
          ) : (
            <img
              style={{ transform: 'rotate(180deg)' }}
              src="/assets/images/arrow/pageLeftOff.svg"
              alt=""
            />
          )}
        </ArrowButton>
        <ArrowButton
          style={{
            width: '36px',
            height: '36px',
            transform: currentPage === totalPages ? 'rotate(180deg)' : '',
          }}
          onClick={
            currentPage !== totalPages
              ? () => handleChangePage(totalPages)
              : () => {}
          }
        >
          {currentPage !== totalPages ? (
            <img src="/assets/images/arrow/double_arrow_right_on.svg" alt="" />
          ) : (
            <img src="/assets/images/arrow/double_arrow_left_off.svg" alt="" />
          )}
        </ArrowButton>
      </ArrowBox>
    </PaginationContainer>
  );
};

export default Pagination;

interface ArrowBoxProps {
  isEnabled: boolean;
}

const ArrowBox = styled.div<ArrowBoxProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  cursor: ${({ isEnabled }) =>
    isEnabled ? 'pointer' : 'default'}; /* props 접근 방식 수정 */
  color: ${({ isEnabled }) =>
    isEnabled ? '#616161' : 'rgba(55, 56, 60, 0.16)'};
`;

interface ContainerProps {
  removeMargin?: boolean;
}

const PaginationContainer = styled.div<ContainerProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 12px;
  // margin-top: 40px;
  // margin-bottom: 40px;

  margin-top: ${({ removeMargin }: ContainerProps) =>
    removeMargin ? '0px' : '40px'};

  margin-bottom: ${({ removeMargin }: ContainerProps) =>
    removeMargin ? '0px' : '40px'};
`;

const PageNumbersContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const PageNumberText = styled.span<{ isActive: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-family: 'Spoqa Han Sans Neo';
  width: 36px;
  height: 36px;
  font-size: 14px;
  font-weight: 700;
  line-height: 26.4px;
  color: ${({ isActive }) => (isActive ? '#008AFF' : 'rgba(23, 30, 38, 0.56)')};
  background-color: ${({ isActive }) => (isActive ? '#EAF2FE' : 'none')};
  border-radius: 9999px;
  cursor: pointer;
`;

const ArrowButton = styled.div`
  cursor: pointer;
  display: flex;
  // img {
  //   width: 14px;
  //   height: 8px;
  // }
`;
